import makeApiCall from "./master/axiosIndex";
export const normsApis = {
  createNorm: (data: any): Promise<any> => {
    return makeApiCall({ url: "/norms/create", method: "post", data });
  },
  getNormsDropdown: (): Promise<any> => {
    return makeApiCall({ url: "/norms/dropdown", method: "get" });
  },
  getNormsList: (data: any): Promise<any> => {
    return makeApiCall({ url: "/norms/list", method: "get", params: data });
  },
  getNormById: (normId: string): Promise<any> => {
    return makeApiCall({ url: `/norms/id/${normId}`, method: "get" });
  },
  updateNorm: (data: any): Promise<any> => {
    return makeApiCall({ url: "/norms/update", method: "put", data });
  },
  activateNorm: (normId: any): Promise<any> => {
    return makeApiCall({
      url: "/norms/activate",
      method: "patch",
      data: { normId },
    });
  },
  deactivateNorm: (normId: any): Promise<any> => {
    return makeApiCall({
      url: "/norms/deactivate",
      method: "patch",
      data: { normId },
    });
  },
  // Auto-generates the task's material BOQ lines from the norm's active
  // material lines (qty = work qty × consumptionNorm × (1 + wastage)).
  attachNormToTask: (data: {
    taskId: number;
    normId: number;
    overrideQty?: number;
    replaceExisting?: boolean;
  }): Promise<any> => {
    return makeApiCall({ url: "/norms/attachToTask", method: "post", data });
  },
  // Decoupled requirement: records the norm's active materials as a computed
  // requirement on the task (qty = work qty × consumptionNorm × (1 + wastage)),
  // independent of BOQ. Re-applying the same norm replaces its rows.
  applyNormToTask: (data: {
    taskId: number;
    normId: number;
    overrideQty?: number;
  }): Promise<any> => {
    return makeApiCall({ url: "/norms/task/apply", method: "post", data });
  },
  removeNormFromTask: (data: {
    taskId: number;
    normId: number;
    reason?: string;
  }): Promise<any> => {
    return makeApiCall({ url: "/norms/task/remove", method: "post", data });
  },
  // Materials-from-norm list for a task, grouped by the norm that produced them.
  getTaskNormMaterials: (taskId: number): Promise<any> => {
    return makeApiCall({ url: `/norms/task/${taskId}/materials`, method: "get" });
  },
  // Read-only norm material requirement rolled up per material to a hierarchy
  // node (sum of quantity + value across all norm-applied tasks below it).
  getActivityNormMaterials: (activityId: number): Promise<any> => {
    return makeApiCall({
      url: `/norms/activity/${activityId}/materials`,
      method: "get",
    });
  },
  getPhaseNormMaterials: (phaseId: number): Promise<any> => {
    return makeApiCall({ url: `/norms/phase/${phaseId}/materials`, method: "get" });
  },
  getProjectNormMaterials: (projectId: number): Promise<any> => {
    return makeApiCall({
      url: `/norms/project/${projectId}/materials`,
      method: "get",
    });
  },
  // Bulk apply-norm-to-tasks staged upload (rows: TaskID, NormCode).
  applyNormExcel: (data: FormData): Promise<any> => {
    return makeApiCall({
      url: "/norms/upload/applyNormExcel",
      method: "post",
      data,
    });
  },
  uploadNormsExcel: (data: FormData): Promise<any> => {
    return makeApiCall({
      url: "/norms/upload/normsExcel",
      method: "post",
      data,
    });
  },
  // Async master export: enqueue a build job (worker builds the xlsx in the
  // upload-template format and stores it in DMS). Returns the request reportId.
  // Scoped to the given projectId (0 = org master).
  requestNormsExport: (comment?: string, projectId?: number): Promise<any> => {
    return makeApiCall({
      url: "/norms/export/request",
      method: "post",
      data: { comment, projectId },
    });
  },
  // Copies the organization-master set (projectId 0) into the given project.
  // Returns { insertedCount, message }.
  duplicateToProject: (projectId: number): Promise<any> => {
    return makeApiCall({
      url: "/norms/duplicate",
      method: "post",
      data: { projectId },
    });
  },
  // Recent norms export requests (poll target). Processed rows carry filePath.
  fetchNormsExportList: (): Promise<any> => {
    return makeApiCall({ url: "/norms/export/list", method: "get" });
  },
};
